import React, {useState} from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

const FeedbackDialog = ({open, handleClose, handleSubmit}) => {
  const [feedbackType, updateFeedbackType] = useState('content');
  const [comments, updateComments] = useState('');
  // const [email, updateEmail] = useState('');
  const [buttonDisabled, updateButtonDisabled] = useState(false);

  const validateSubmission = () => {
    // if (false || !email || !email.length) {
    //   alert("You must provide your email address for correspondance");
    updateButtonDisabled(true);
    if (!comments || !comments.length) {
      alert("You didn't provide any feedback!");
    } else {
      handleSubmit({
        // email,
        comments,
        feedbackType
      }, ({ok}) => {
        if (!ok) {
          alert("Error sending feedback. Contact support@fishpath.org");
        } else {
          handleClose();
          updateButtonDisabled(false);
          updateFeedbackType('content');
          updateComments('');
        }
      });
    }
  }

  const actions = [
    <FlatButton
      label="Cancel"
      onClick={handleClose}
    />,
    <RaisedButton
      label="Submit"
      primary={true}
      onClick={validateSubmission}
      disabled={buttonDisabled}
    />,
  ];


  return (
    <Dialog title="Send Us Feedback" open={open} actions={actions} onRequestClose={handleClose} autoScrollBodyContent={true}>
      <SelectField
        floatingLabelText="What kind of feedback are you providing?"
        value={feedbackType}
        onChange={(e, i, v) => updateFeedbackType(v)}
        style={{width: 300}}
      >
        <MenuItem value="content" primaryText="Content Related" />
        <MenuItem value="software" primaryText="Software Issue" />
      </SelectField>
      <br />
      <br />
      <textarea value={comments} onChange={(e) => updateComments(e.target.value)} placeholder="Your comments" style={{width: '95%', height: 200, border: '1px solid #eeee', fontFamily: 'Roboto, sans-serif', fontSize: 16}} />
      <br />
      <br />
      <i style={{fontSize: 14}}>Email <a href="mailto:support@fishpath.org" rel="noopener noreferrer" target="_blank">support@fishpath.org</a> if you'd like to include attachments or screenshots.</i>
    </Dialog>
  )
}

export default FeedbackDialog;
